export type SurveyItemLivePricing = {
    zoneHighestCostPrice?: number | null;
    cashbuildCostPrice?: number | null;
    pnlCostPrice?: number | null;
    currentCashbuildPrice?: number | null;
    currentPnlPrice?: number | null;
};

export function readSurveyItemLivePricing(
    item: SurveyItemLivePricing,
): Required<SurveyItemLivePricing> {
    return {
        zoneHighestCostPrice: item.zoneHighestCostPrice ?? null,
        cashbuildCostPrice: item.cashbuildCostPrice ?? null,
        pnlCostPrice: item.pnlCostPrice ?? null,
        currentCashbuildPrice: item.currentCashbuildPrice ?? null,
        currentPnlPrice: item.currentPnlPrice ?? null,
    };
}
